/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { Grid } from "semantic-ui-react";
import "./multimediaFiles.scss";

export default function MultimediaFiles(props) {
  const t = useTranslation();

  return (
    <Grid>
      <Grid.Row columns={1}>
        <Grid.Column>
          <h3 className="title-section">{t("title.multimedia-files")}</h3>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}
